import { ThemeAction, SWITCH_THEME } from '../actions/themeActions';
import { AppTheme, AppThemeMode, DARK_THEME,  FROM_DEVICE_THEME_MODE, FORCED_LIGHT_THEME_MODE, FORCED_DARK_THEME_MODE,LIGHT_THEME } from '../models/theme';

export const themeReducer = (theme: AppTheme, themeMode: AppThemeMode, action: ThemeAction): AppTheme => {
    
    switch (action.type) {
        case SWITCH_THEME:
            switch (themeMode) {
                case FORCED_DARK_THEME_MODE:
                    return  DARK_THEME;
                case FORCED_LIGHT_THEME_MODE:
                    return LIGHT_THEME;
                case FROM_DEVICE_THEME_MODE:
                    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? DARK_THEME : LIGHT_THEME;
                default:
                    return LIGHT_THEME;
            }
        default:
            return theme;
    }
};
